/* eslint-disable */
import { lazy } from "react";
import { USER_ROLE } from "constants.js";
import { DEFAULT_PATHS } from "config.js";

const dashboards = {
  index: lazy(() => import("views/dashboards/Dashboard")),
  analyticsCashback: lazy(() =>
    import("views/dashboards/AnalyticsCashbackDashboard"),
  ),
  analyticsUserHealth: lazy(() =>
    import("views/dashboards/AnalyticsUserHealthDashboard"),
  ),
  analyticsCampaign: lazy(() =>
    import("views/dashboards/AnalyticsCampaignDashboard"),
  ),
  analyticsWithdrawal: lazy(() =>
    import("views/dashboards/AnalyticsWithdrawalDashboard"),
  ),
  userIndex: lazy(() => import("views/dashboards/DashboardUser")),
  cashbackRewardIndex: lazy(() =>
    import("views/dashboards/DashboardCashbackReward"),
  ),
  campaignIndex: lazy(() => import("views/dashboards/DashboardCampaign")),
  customerSupport: lazy(() => import("views/dashboards/CustomerSupport")),
  EditUserDetails: lazy(() =>
    import("views/dashboards/Components/EditUserDetails"),
  ),
  financeIndex: lazy(() => import("views/dashboards/DashboardFinance")),
  recurring: lazy(() => import("views/dashboards/DashboardRecurring")),
  allSubscriptions: lazy(() => import("views/dashboards/AllSubscriptions")),
  allTransactions: lazy(() => import("views/dashboards/AllTransactions")),
  allCashbacksAndRewrds: lazy(() =>
    import("views/dashboards/AllCashbacksAndRewards"),
  ),
  AllCampaignHistory: lazy(() => import("views/dashboards/AllCampaignHistory")),
  allAuditlogs: lazy(() => import("views/dashboards/AllAuditlogs")),
  allWithdrawalRequets: lazy(() =>
    import("views/dashboards/AllWithdeawalRequest"),
  ),
  settings: lazy(() => import("views/dashboards/Settings")),
  notifications: lazy(() => import("views/dashboards/Notifications")),
  sendNotifications: lazy(() => import("views/dashboards/SendNotification")),
  createWhatsappTemplate: lazy(() =>
    import("views/dashboards/CreateWhatsappTemplate"),
  ),
  sendWhatsappMessage: lazy(() =>
    import("views/dashboards/SendWhatsappMessage"),
  ),
  clickAnalytics: lazy(() => import("views/dashboards/ClickAnalytics")),
  tailwindDashboard: lazy(() => import("views/dashboards/TailwindDashboard")),
  userHealthDashboard: lazy(() =>
    import("views/dashboards/UserHealthDashboard"),
  ),
  allStatements: lazy(() => import("views/dashboards/AllStatements")),
  // index2: lazy(() => import('views/dashboards/Dashboards')),
};

const supportChat = {
  inbox: lazy(() => import("views/supportChat/SupportChatInbox")),
  flows: lazy(() => import("views/supportChat/GuidedFlowsList")),
  flowEditor: lazy(() => import("views/supportChat/FlowEditor")),
};
const application = {
  banners: lazy(() => import("views/application/banners/Banners")),
  add: lazy(() => import("views/application/banners/Banner")),
  homeManager: lazy(() => import("views/application/home-manager/HomeManager")),
  section: lazy(() => import("views/application/home-manager/Section")),
  media: lazy(() => import("views/application/media/Media")),
  addMedia: lazy(() => import("views/application/media/AddMedia")),
};

const userManagement = {
  roles: lazy(() => import("views/userManagement/roles/Roles")),
  admins: lazy(() => import("views/userManagement/admins/Admins")),
  customers: lazy(() => import("views/userManagement/customers/Customers")),
  customerDetails: lazy(() =>
    import("views/userManagement/customers/CustomerDetails"),
  ),
};
const productsManagement = {
  categories: lazy(() =>
    import("views/productManagement/categories/Categories"),
  ),
  category: lazy(() => import("views/productManagement/categories/Category")),
  products: lazy(() => import("views/productManagement/products/Products")),
  product: lazy(() => import("views/productManagement/products/Product")),
};
const salesManagement = {
  roundup: lazy(() => import("views/salesManagement/roundup/Roundup")),
  rewardPoints: lazy(() =>
    import("views/salesManagement/rewardPoints/RewardPoints"),
  ),
  updatedVendorCampaign: lazy(() =>
    import("views/salesManagement/affiliations/UpdatedVendorCampaigns"),
  ),
  affiliationsDetails: lazy(() =>
    import("views/salesManagement/affiliations/AffiliationsDetails"),
  ),
  AddAdmitadCampaign: lazy(() =>
    import("views/salesManagement/affiliations/AddAdmitadCampaign"),
  ),
  affiliations: lazy(() =>
    import("views/salesManagement/affiliations/Affiliations"),
  ),
  OttenCampaign: lazy(() =>
    import("views/salesManagement/affiliations/OttenCampaign"),
  ),
  PublishedCampaign: lazy(() =>
    import("views/salesManagement/affiliations/PublishedCampaign"),
  ),
  UpdatePublishedCampaign: lazy(() =>
    import("views/salesManagement/affiliations/UpdatePublishedCampaignDetails"),
  ),
  compareUpdatedCampaign: lazy(() =>
    import("views/salesManagement/affiliations/CompareUpdatedCampaign"),
  ),
  OttenCampaignDetails: lazy(() =>
    import("views/salesManagement/affiliations/CampaignDetails"),
  ),
  updateOttenCampaignDetails: lazy(() =>
    import("views/salesManagement/affiliations/UpdateCampaignDetails"),
  ),
  updateVcommission: lazy(() =>
    import("views/salesManagement/affiliations/UpdateVcommision"),
  ),
};
const voucherManagement = {
  categories: lazy(() =>
    import("views/voucherManagement/categories/Categories"),
  ),
  category: lazy(() => import("views/voucherManagement/categories/Category")),
  products: lazy(() => import("views/voucherManagement/products/Products")),
  product: lazy(() => import("views/voucherManagement/products/Product")),
  publishedVouchers: lazy(() =>
    import("views/voucherManagement/voucher/PublishedVoucher"),
  ),
};

const appRoot = DEFAULT_PATHS.APP.endsWith("/")
  ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length)
  : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/dashboard/dashboard-users`,
    },
    {
      path: `${appRoot}/dashboard`,
      component: dashboards.index,
      label: "Dashboard",
      icon: "home",
      subs: [
        {
          path: "/dashboard-users",
          label: "Dashboard Users",
          icon: "user",
          component: dashboards.userIndex,
        },
        {
          path: "/dashboard-finance",
          label: "Dashboard Finance",
          icon: "dollar",
          component: dashboards.financeIndex,
        },
        {
          path: "/dashboard-recurring",
          label: "Dashboard Recurring",
          icon: "dollar",
          component: dashboards.recurring,
          
        },
        {
          path: "/all-subscriptions",
          label: "All Subscriptions",
          icon: "dollar",
          component: dashboards.allSubscriptions,
          hideInMenu: true,

        },
        {
          path: "/dashboard-cashback-reward",
          label: "Cashback & Reward",
          icon: "dollar",
          component: dashboards.cashbackRewardIndex,
        },
        {
          path: "/dashboard-campaign",
          label: "Campaign Dashboard",
          icon: "dollar",
          component: dashboards.campaignIndex,
        },
        {
          path: "/settings",
          label: "System Feature",
          icon: "gear",
          component: dashboards.settings,
          hideInMenu: true,
        },
        {
          path: "/notifications",
          label: "System Feature",
          icon: "bell",
          component: dashboards.notifications,
          hideInMenu: true,
        },
        {
          path: "/click-analytics",
          label: "Click Analytics",
          icon: "dollar",
          component: dashboards.clickAnalytics,
          hideInMenu: true,
        },
        {
          path: "/send-notification",
          label: "System Feature",
          icon: "bell",
          component: dashboards.sendNotifications,
          hideInMenu: true,
        },
        {
          path: "/create-whatsapp-template",
          label: "Create WhatsApp Template",
          icon: "message",
          component: dashboards.createWhatsappTemplate,
          hideInMenu: true,
        },
        {
          path: "/send-whatsapp-message",
          label: "Send WhatsApp Message",
          icon: "send",
          component: dashboards.sendWhatsappMessage,
          hideInMenu: true,
        },
        {
          path: "/all-transactions",
          label: "All Transactions",
          icon: "gear",
          component: dashboards.allTransactions,
          hideInMenu: true,
        },
        {
          path: "/all-cashbacks-and-rewards",
          label: "All Cashbacks And Rewards",
          icon: "gear",
          component: dashboards.allCashbacksAndRewrds,
          hideInMenu: true,
        },
        {
          path: "/all-campaign-history",
          label: "All Campaign History",
          icon: "gear",
          component: dashboards.AllCampaignHistory,
          hideInMenu: true,
        },
        {
          path: "/all-auditlogs",
          label: "All auditlogs",
          icon: "gear",
          component: dashboards.allAuditlogs,
          hideInMenu: true,
        },
        {
          path: "/all-statements",
          label: "All statements",
          icon: "gear",
          component: dashboards.allStatements,
          hideInMenu: true,
        },
        {
          path: "/all-withdrawal-requets",
          label: "All withdrawal requets",
          icon: "gear",
          component: dashboards.allWithdrawalRequets,
          hideInMenu: true,
        },
        {
          path: "/customer-support/:customer_id",
          label: "Edit User",
          icon: "gear",
          component: dashboards.EditUserDetails,
          hideInMenu: true,
        },
        {
          path: "/customer-support",
          label: "Customer Support",
          icon: "user",
          component: dashboards.customerSupport,
        },
        {
          path: "/tailwind-dashboard",
          label: "Tailwind Dashboard",
          icon: "user",
          component: dashboards.tailwindDashboard,
        },
        {
          path: "/user-health",
          label: "User Health Dashboard",
          icon: "activity",
          component: dashboards.userHealthDashboard,
        },
      ],
    },
    {
      path: `${appRoot}/analytics`,
      label: "Analytics",
      icon: "chart-4",
      component: dashboards.index,
      subs: [
        {
          path: "/cashback",
          label: "Cashback Analytics",
          icon: "chart-4",
          component: dashboards.analyticsCashback,
        },
        {
          path: "/user-health",
          label: "User Health Analytics",
          icon: "activity",
          component: dashboards.analyticsUserHealth,
        },
        {
          path: "/campaigns",
          label: "Campaign Analytics",
          icon: "chart-4",
          component: dashboards.analyticsCampaign,
        },
        {
          path: "/withdrawals",
          label: "Withdrawal Analytics",
          icon: "money",
          component: dashboards.analyticsWithdrawal,
        },
      ],
    },
    {
      path: `${appRoot}/support-chat`,
      label: "Support Chat",
      icon: "message",
      component: dashboards.index,
      subs: [
        {
          path: "/inbox",
          label: "Chat Board",
          icon: "message",
          component: supportChat.inbox,
        },
        {
          path: "/flows/:flowId",
          label: "Edit Flow",
          icon: "list",
          component: supportChat.flowEditor,
          hideInMenu: true,
        },
        {
          path: "/flows",
          label: "Guided Flows",
          icon: "list",
          component: supportChat.flows,
          exact: true,
        },
      ],
    },
    {
      path: `${appRoot}/application`,
      label: "Application",
      exact: true,
      icon: "mobile",
      component: "",
      subs: [
        {
          path: "/banners",
          label: "Banners",
          icon: "image",
          component: application.banners,
          // Define additional routes that won't show in menu
          subs: [
            {
              path: "/add",
              label: "Add Banner",
              component: application.add,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: "/home-manager",
          label: "Home Manager",
          icon: "home",
          component: application.homeManager,
          // Define additional routes that won't show in menu
          subs: [
            {
              path: "/section",
              label: "section",
              component: application.section,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: "/media",
          label: "Media",
          icon: "image",
          component: application.media,
          subs: [
            {
              path: "/add",
              label: "Add Media",
              component: application.addMedia,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
      ],
    },
    {
      path: `${appRoot}/user-management`,
      label: "User Management",
      icon: "user",
      component: "",
      subs: [
        {
          path: "/roles",
          label: "Roles",
          icon: "shield",
          component: userManagement.roles,
        },
        {
          path: "/admins",
          label: "Admins",
          icon: "cpu",
          component: userManagement.admins,
        },
        {
          path: "/customers",
          label: "Customers",
          icon: "user",
          component: userManagement.customers,
          subs: [
            {
              path: "/:id",
              label: "Customer Deatils",
              component: userManagement.customerDetails,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
      ],
    },
    {
      path: `${appRoot}/product-management`,
      label: "Product Management",
      icon: "cart",
      component: "",
      subs: [
        {
          path: "/categories",
          label: "Categories",
          icon: "tag",
          component: productsManagement.categories,
          subs: [
            {
              path: "/add",
              label: "Add Category",
              component: productsManagement.category,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: "/products",
          label: "Products",
          icon: "cart",
          component: productsManagement.products,
          subs: [
            {
              path: "/add",
              label: "Add Product",
              component: productsManagement.product,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
      ],
    },
    {
      path: `${appRoot}/sales-management`,
      label: "Sales & Services",
      icon: "activity",
      component: "",
      subs: [
        // { path: `${appRoot}/dashboard`, label: 'Coupons', icon: 'tag', component: dashboards.index },
        // { path: `${appRoot}/dashboard`, label: 'Discounts', icon: 'tag', component: dashboards.index },
        // { path: `${appRoot}/dashboard`, label: 'Cashback', icon: 'tag', component: dashboards.index },
        // { path: `${appRoot}/dashboard`, label: 'Investments', icon: 'tag', component: dashboards.index },
        {
          path: `${appRoot}/roundup`,
          label: "Roundup",
          icon: "abacus",
          component: salesManagement.roundup,
        },
        {
          path: `${appRoot}/reward-points`,
          label: "Reward Points",
          icon: "abacus",
          component: salesManagement.rewardPoints,
        },

        {
          path: `${appRoot}/affiliations`,
          label: "Affiliations",
          icon: "tag",
          component: salesManagement.affiliations,
          subs: [
            {
              path: "/details",
              label: "Campaign Details",
              component: salesManagement.affiliationsDetails,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
            {
              path: "/add-admitad-campaign",
              label: "Add Admitad Campaign",
              component: salesManagement.AddAdmitadCampaign,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: `${appRoot}/otten-campaign`,
          label: "Otten Campaign",
          icon: "tag",
          component: salesManagement.OttenCampaign,
          subs: [
            {
              path: "/campaign-details",
              label: "Otten Campaign Details",
              component: salesManagement.OttenCampaignDetails,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
            {
              path: "/campaign-details-update",
              label: "Update Otten Campaign Details",
              component: salesManagement.updateOttenCampaignDetails,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
            {
              path: "/vcommission-campaign-update",
              label: "Update Otten Campaign Details",
              component: salesManagement.updateVcommission,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: `${appRoot}/published-campaign`,
          label: "Published Campaign",
          icon: "tag",
          component: salesManagement.PublishedCampaign,
          subs: [
            {
              path: "/details",
              label: "Published Campaign Details",
              component: salesManagement.UpdatePublishedCampaign,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: `${appRoot}/updated-vendor-campaign`,
          label: "Updated Vendor Campaign",
          icon: "tag",
          component: salesManagement.updatedVendorCampaign,
          subs: [
            {
              path: "/compare",
              label: "Compare Updated Campaign Details",
              component: salesManagement.compareUpdatedCampaign,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
      ],
    },
    {
      path: `${appRoot}/voucher-management`,
      label: "Voucher Management",
      icon: "tag",
      component: "",
      subs: [
        {
          path: "/categories",
          label: "Categories",
          icon: "tag",
          component: voucherManagement.categories,
          subs: [
            {
              path: "/add",
              label: "Add Category",
              component: voucherManagement.category,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: "/products",
          label: "Products",
          icon: "gift",
          component: voucherManagement.products,
          subs: [
            {
              path: "/add",
              label: "Add Product",
              component: voucherManagement.product,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
            {
              path: "/product/:productId",
              label: "Product Details",
              component: voucherManagement.product,
              hideInMenu: true, // This will hide it from sidebar/menu
            },
          ],
        },
        {
          path: "/published-vouchers",
          label: "Published Vouchers",
          icon: "tag",
          component: voucherManagement.publishedVouchers,
        },
      ],
    },

    // {
    //   path: `${appRoot}/dashboard`,
    //   label: 'Business Management',
    //   icon: 'cart',
    //   component: '',
    //   subs: [
    //     { path: `${appRoot}/dashboard`, label: 'Venders', icon: 'tag', component: dashboards.index },
    //     { path: `${appRoot}/dashboard`, label: 'Organizations', icon: 'tag', component: dashboards.index },
    //   ],
    // },

    // {
    //   path: `${appRoot}/dashboard`,
    //   label: 'Reporting & Analytics',
    //   icon: 'cart',
    //   component: '',
    //   subs: [
    //     { path: `${appRoot}/dashboard`, label: 'Transactions', icon: 'tag', component: dashboards.index },
    //     { path: `${appRoot}/dashboard`, label: 'Reports', icon: 'tag', component: dashboards.index },
    //   ],
    // },
  ],
  sidebarItems: [],
};
export default routesAndMenuItems;
